var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtcExfinito(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 36,
    viewBox: "0 0 347 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 4,
    r: 1,
    fill: "#FCFCFD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 4,
    r: 1,
    fill: "#00A693"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter6_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter7_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter9_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter10_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter11_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter12_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter13_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 18,
    r: 1,
    fill: "#00A693"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter15_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter16_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter17_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 18,
    r: 1,
    fill: "#FCFCFD"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter19_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter20_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 32,
    r: 1,
    fill: "#00A693"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter22_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter23_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter24_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter25_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 32,
    r: 1,
    fill: "#00A693"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter27_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter28_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter29_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3399_2250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-31-outside-1_3399_2250",
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 3.38013,
    width: 72,
    height: 29,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 111,
    y: 3.38013,
    width: 72,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.891 4.78819H120.976C122.701 4.78819 124.355 5.12728 125.938 5.80545C127.52 6.48362 128.882 7.39379 130.024 8.53597C131.167 9.67815 132.077 11.0404 132.755 12.6228C133.433 14.2052 133.772 15.859 133.772 17.5842C133.772 19.3093 133.433 20.9631 132.755 22.5455C132.077 24.1279 131.167 25.4902 130.024 26.6324C128.882 27.7745 127.52 28.6847 125.938 29.3629C124.355 30.041 122.701 30.3801 120.976 30.3801H113.891C113.546 30.3801 113.278 30.2849 113.088 30.0946C112.91 29.8923 112.82 29.6484 112.82 29.3629C112.82 29.0773 112.91 28.8275 113.088 28.6133C113.278 28.3992 113.546 28.2921 113.891 28.2921H120.976C122.428 28.2921 123.808 28.0125 125.117 27.4533C126.437 26.8822 127.573 26.1208 128.525 25.1689C129.477 24.2171 130.233 23.0809 130.792 21.7603C131.363 20.4277 131.648 19.0357 131.648 17.5842C131.648 16.1326 131.363 14.7466 130.792 13.4259C130.233 12.0934 129.477 10.9512 128.525 9.99938C127.573 9.04757 126.437 8.29206 125.117 7.73287C123.808 7.16178 122.428 6.87624 120.976 6.87624H113.891C113.546 6.87624 113.278 6.78106 113.088 6.59069C112.91 6.38843 112.82 6.14453 112.82 5.85899C112.82 5.57344 112.91 5.32359 113.088 5.10943C113.278 4.89527 113.546 4.78819 113.891 4.78819ZM154.314 18.655H139.501V28.2921H154.314C154.635 28.2921 154.885 28.3992 155.063 28.6133C155.242 28.8275 155.331 29.0773 155.331 29.3629C155.331 29.6484 155.242 29.8923 155.063 30.0946C154.897 30.2849 154.647 30.3801 154.314 30.3801H138.484C138.186 30.3801 137.93 30.279 137.716 30.0767C137.514 29.8745 137.413 29.6246 137.413 29.3272V17.5842C137.413 17.3105 137.52 17.0666 137.734 16.8525C137.948 16.6383 138.198 16.5312 138.484 16.5312H154.314C154.635 16.5312 154.885 16.6383 155.063 16.8525C155.242 17.0547 155.331 17.2986 155.331 17.5842C155.331 17.8816 155.242 18.1374 155.063 18.3516C154.897 18.5538 154.647 18.655 154.314 18.655ZM154.314 6.87624H138.484C138.139 6.87624 137.871 6.78106 137.681 6.59069C137.502 6.38843 137.413 6.14453 137.413 5.85899C137.413 5.57344 137.502 5.32359 137.681 5.10943C137.871 4.89527 138.139 4.78819 138.484 4.78819H154.314C154.635 4.78819 154.885 4.89527 155.063 5.10943C155.242 5.32359 155.331 5.57344 155.331 5.85899C155.331 6.14453 155.242 6.38843 155.063 6.59069C154.897 6.78106 154.647 6.87624 154.314 6.87624ZM179.12 30.0232L169.947 19.1547L160.774 30.0232C160.572 30.2612 160.316 30.3801 160.007 30.3801C159.733 30.3801 159.489 30.279 159.275 30.0767C159.073 29.8745 158.971 29.6365 158.971 29.3629C158.971 29.1368 159.061 28.9167 159.239 28.7026L168.626 17.5842L159.239 6.48362C159.061 6.26946 158.971 6.04935 158.971 5.82329C158.971 5.54965 159.079 5.31169 159.293 5.10943C159.519 4.89527 159.769 4.78819 160.042 4.78819C160.316 4.78819 160.56 4.91312 160.774 5.16297L169.947 16.0137L179.12 5.16297C179.334 4.91312 179.59 4.78819 179.888 4.78819C180.161 4.78819 180.399 4.89527 180.601 5.10943C180.804 5.31169 180.905 5.54965 180.905 5.82329C180.905 6.06125 180.822 6.28135 180.655 6.48362L171.268 17.5842L180.655 28.7026C180.822 28.9048 180.905 29.1249 180.905 29.3629C180.905 29.6365 180.798 29.8745 180.584 30.0767C180.369 30.279 180.126 30.3801 179.852 30.3801C179.566 30.3801 179.322 30.2612 179.12 30.0232Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.891 4.78819H120.976C122.701 4.78819 124.355 5.12728 125.938 5.80545C127.52 6.48362 128.882 7.39379 130.024 8.53597C131.167 9.67815 132.077 11.0404 132.755 12.6228C133.433 14.2052 133.772 15.859 133.772 17.5842C133.772 19.3093 133.433 20.9631 132.755 22.5455C132.077 24.1279 131.167 25.4902 130.024 26.6324C128.882 27.7745 127.52 28.6847 125.938 29.3629C124.355 30.041 122.701 30.3801 120.976 30.3801H113.891C113.546 30.3801 113.278 30.2849 113.088 30.0946C112.91 29.8923 112.82 29.6484 112.82 29.3629C112.82 29.0773 112.91 28.8275 113.088 28.6133C113.278 28.3992 113.546 28.2921 113.891 28.2921H120.976C122.428 28.2921 123.808 28.0125 125.117 27.4533C126.437 26.8822 127.573 26.1208 128.525 25.1689C129.477 24.2171 130.233 23.0809 130.792 21.7603C131.363 20.4277 131.648 19.0357 131.648 17.5842C131.648 16.1326 131.363 14.7466 130.792 13.4259C130.233 12.0934 129.477 10.9512 128.525 9.99938C127.573 9.04757 126.437 8.29206 125.117 7.73287C123.808 7.16178 122.428 6.87624 120.976 6.87624H113.891C113.546 6.87624 113.278 6.78106 113.088 6.59069C112.91 6.38843 112.82 6.14453 112.82 5.85899C112.82 5.57344 112.91 5.32359 113.088 5.10943C113.278 4.89527 113.546 4.78819 113.891 4.78819ZM154.314 18.655H139.501V28.2921H154.314C154.635 28.2921 154.885 28.3992 155.063 28.6133C155.242 28.8275 155.331 29.0773 155.331 29.3629C155.331 29.6484 155.242 29.8923 155.063 30.0946C154.897 30.2849 154.647 30.3801 154.314 30.3801H138.484C138.186 30.3801 137.93 30.279 137.716 30.0767C137.514 29.8745 137.413 29.6246 137.413 29.3272V17.5842C137.413 17.3105 137.52 17.0666 137.734 16.8525C137.948 16.6383 138.198 16.5312 138.484 16.5312H154.314C154.635 16.5312 154.885 16.6383 155.063 16.8525C155.242 17.0547 155.331 17.2986 155.331 17.5842C155.331 17.8816 155.242 18.1374 155.063 18.3516C154.897 18.5538 154.647 18.655 154.314 18.655ZM154.314 6.87624H138.484C138.139 6.87624 137.871 6.78106 137.681 6.59069C137.502 6.38843 137.413 6.14453 137.413 5.85899C137.413 5.57344 137.502 5.32359 137.681 5.10943C137.871 4.89527 138.139 4.78819 138.484 4.78819H154.314C154.635 4.78819 154.885 4.89527 155.063 5.10943C155.242 5.32359 155.331 5.57344 155.331 5.85899C155.331 6.14453 155.242 6.38843 155.063 6.59069C154.897 6.78106 154.647 6.87624 154.314 6.87624ZM179.12 30.0232L169.947 19.1547L160.774 30.0232C160.572 30.2612 160.316 30.3801 160.007 30.3801C159.733 30.3801 159.489 30.279 159.275 30.0767C159.073 29.8745 158.971 29.6365 158.971 29.3629C158.971 29.1368 159.061 28.9167 159.239 28.7026L168.626 17.5842L159.239 6.48362C159.061 6.26946 158.971 6.04935 158.971 5.82329C158.971 5.54965 159.079 5.31169 159.293 5.10943C159.519 4.89527 159.769 4.78819 160.042 4.78819C160.316 4.78819 160.56 4.91312 160.774 5.16297L169.947 16.0137L179.12 5.16297C179.334 4.91312 179.59 4.78819 179.888 4.78819C180.161 4.78819 180.399 4.89527 180.601 5.10943C180.804 5.31169 180.905 5.54965 180.905 5.82329C180.905 6.06125 180.822 6.28135 180.655 6.48362L171.268 17.5842L180.655 28.7026C180.822 28.9048 180.905 29.1249 180.905 29.3629C180.905 29.6365 180.798 29.8745 180.584 30.0767C180.369 30.279 180.126 30.3801 179.852 30.3801C179.566 30.3801 179.322 30.2612 179.12 30.0232Z",
    fill: "#3AD2AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.088 30.0946L112.266 30.82L112.289 30.8457L112.313 30.8699L113.088 30.0946ZM113.088 28.6133L112.269 27.8849L112.257 27.8979L112.246 27.9114L113.088 28.6133ZM125.117 27.4533L125.547 28.4616L125.552 28.4597L125.117 27.4533ZM130.792 21.7603L129.784 21.3283L129.782 21.3327L130.792 21.7603ZM130.792 13.4259L129.781 13.8502L129.785 13.8611L130.792 13.4259ZM125.117 7.73287L124.678 8.73791L124.689 8.74258L125.117 7.73287ZM113.088 6.59069L112.266 7.31616L112.289 7.34183L112.313 7.36603L113.088 6.59069ZM113.088 5.10943L112.269 4.38096L112.257 4.39404L112.246 4.40748L113.088 5.10943ZM113.891 4.78819V5.88469H120.976V4.78819V3.6917H113.891V4.78819ZM120.976 4.78819V5.88469C122.553 5.88469 124.06 6.19373 125.506 6.81328L125.938 5.80545L126.369 4.79761C124.65 4.06082 122.85 3.6917 120.976 3.6917V4.78819ZM125.938 5.80545L125.506 6.81328C126.968 7.44016 128.212 8.27412 129.249 9.3113L130.024 8.53597L130.8 7.76063C129.553 6.51346 128.072 5.52708 126.369 4.79761L125.938 5.80545ZM130.024 8.53597L129.249 9.3113C130.286 10.3485 131.12 11.592 131.747 13.0548L132.755 12.6228L133.763 12.1909C133.033 10.4888 132.047 9.0078 130.8 7.76063L130.024 8.53597ZM132.755 12.6228L131.747 13.0548C132.367 14.5004 132.676 16.0072 132.676 17.5842H133.772H134.869C134.869 15.7108 134.5 13.9101 133.763 12.1909L132.755 12.6228ZM133.772 17.5842H132.676C132.676 19.1611 132.367 20.668 131.747 22.1136L132.755 22.5455L133.763 22.9774C134.5 21.2583 134.869 19.4575 134.869 17.5842H133.772ZM132.755 22.5455L131.747 22.1136C131.12 23.5763 130.286 24.8198 129.249 25.857L130.024 26.6324L130.8 27.4077C132.047 26.1605 133.033 24.6795 133.763 22.9774L132.755 22.5455ZM130.024 26.6324L129.249 25.857C128.212 26.8942 126.968 27.7282 125.506 28.355L125.938 29.3629L126.369 30.3707C128.072 29.6412 129.553 28.6549 130.8 27.4077L130.024 26.6324ZM125.938 29.3629L125.506 28.355C124.06 28.9746 122.553 29.2836 120.976 29.2836V30.3801V31.4766C122.85 31.4766 124.65 31.1075 126.369 30.3707L125.938 29.3629ZM120.976 30.3801V29.2836H113.891V30.3801V31.4766H120.976V30.3801ZM113.891 30.3801V29.2836C113.818 29.2836 113.793 29.2734 113.799 29.2756C113.802 29.2769 113.812 29.2808 113.825 29.289C113.839 29.2973 113.852 29.3077 113.863 29.3192L113.088 30.0946L112.313 30.8699C112.762 31.3195 113.341 31.4766 113.891 31.4766V30.3801ZM113.088 30.0946L113.91 29.3691C113.908 29.3668 113.909 29.3674 113.911 29.3709C113.913 29.3746 113.915 29.3789 113.917 29.3832C113.919 29.3875 113.919 29.3891 113.918 29.387C113.918 29.3847 113.917 29.377 113.917 29.3629H112.82H111.724C111.724 29.8985 111.9 30.405 112.266 30.82L113.088 30.0946ZM112.82 29.3629H113.917C113.917 29.3488 113.918 29.34 113.919 29.3357C113.919 29.3334 113.919 29.332 113.92 29.3312C113.92 29.3305 113.92 29.3302 113.92 29.3301C113.92 29.3301 113.92 29.3301 113.92 29.33C113.92 29.3299 113.92 29.3294 113.921 29.3286C113.922 29.327 113.924 29.3226 113.93 29.3153L113.088 28.6133L112.246 27.9114C111.899 28.3277 111.724 28.8276 111.724 29.3629H112.82ZM113.088 28.6133L113.908 29.3418C113.9 29.3503 113.889 29.3606 113.875 29.3705C113.861 29.3804 113.848 29.3868 113.839 29.3905C113.82 29.3978 113.831 29.3886 113.891 29.3886V28.2921V27.1956C113.303 27.1956 112.709 27.3891 112.269 27.8849L113.088 28.6133ZM113.891 28.2921V29.3886H120.976V28.2921V27.1956H113.891V28.2921ZM120.976 28.2921V29.3886C122.573 29.3886 124.1 29.0802 125.547 28.4616L125.117 27.4533L124.686 26.445C123.516 26.9448 122.283 27.1956 120.976 27.1956V28.2921ZM125.117 27.4533L125.552 28.4597C126.991 27.8376 128.244 27.0005 129.301 25.9443L128.525 25.1689L127.75 24.3936C126.903 25.241 125.884 25.9269 124.681 26.4469L125.117 27.4533ZM128.525 25.1689L129.301 25.9443C130.359 24.8863 131.191 23.6298 131.802 22.1878L130.792 21.7603L129.782 21.3327C129.274 22.532 128.596 23.548 127.75 24.3936L128.525 25.1689ZM130.792 21.7603L131.8 22.1922C132.429 20.723 132.745 19.184 132.745 17.5842H131.648H130.552C130.552 18.8874 130.296 20.1324 129.784 21.3283L130.792 21.7603ZM131.648 17.5842H132.745C132.745 15.9843 132.429 14.45 131.798 12.9907L130.792 13.4259L129.785 13.8611C130.297 15.0431 130.552 16.281 130.552 17.5842H131.648ZM130.792 13.4259L131.803 13.0016C131.193 11.5476 130.36 10.2837 129.301 9.22405L128.525 9.99938L127.75 10.7747C128.594 11.6187 129.273 12.6391 129.781 13.8502L130.792 13.4259ZM128.525 9.99938L129.301 9.22405C128.243 8.16606 126.986 7.33373 125.544 6.72317L125.117 7.73287L124.689 8.74258C125.888 9.2504 126.904 9.92908 127.75 10.7747L128.525 9.99938ZM125.117 7.73287L125.555 6.7279C124.106 6.09543 122.576 5.77975 120.976 5.77975V6.87624V7.97273C122.279 7.97273 123.51 8.22814 124.678 8.73785L125.117 7.73287ZM120.976 6.87624V5.77975H113.891V6.87624V7.97273H120.976V6.87624ZM113.891 6.87624V5.77975C113.818 5.77975 113.793 5.76948 113.799 5.77172C113.802 5.77299 113.812 5.77691 113.825 5.78512C113.839 5.79344 113.852 5.80382 113.863 5.81536L113.088 6.59069L112.313 7.36603C112.762 7.81564 113.341 7.97273 113.891 7.97273V6.87624ZM113.088 6.59069L113.91 5.86523C113.908 5.8629 113.909 5.8635 113.911 5.86705C113.913 5.87067 113.915 5.87504 113.917 5.87934C113.919 5.88357 113.919 5.88524 113.918 5.88311C113.918 5.88081 113.917 5.87316 113.917 5.85899H112.82H111.724C111.724 6.39463 111.9 6.90113 112.266 7.31616L113.088 6.59069ZM112.82 5.85899H113.917C113.917 5.84487 113.918 5.83613 113.919 5.83178C113.919 5.82954 113.919 5.82811 113.92 5.82735C113.92 5.8266 113.92 5.82626 113.92 5.82623C113.92 5.8262 113.92 5.82618 113.92 5.82608C113.92 5.82598 113.92 5.82553 113.921 5.82468C113.922 5.82316 113.924 5.81871 113.93 5.81139L113.088 5.10943L112.246 4.40748C111.899 4.82385 111.724 5.32373 111.724 5.85899H112.82ZM113.088 5.10943L113.908 5.8379C113.9 5.84641 113.889 5.85674 113.875 5.86662C113.861 5.87649 113.848 5.8829 113.839 5.88657C113.82 5.89394 113.831 5.88469 113.891 5.88469V4.78819V3.6917C113.303 3.6917 112.709 3.88524 112.269 4.38096L113.088 5.10943ZM139.501 18.655V17.5585H138.404V18.655H139.501ZM139.501 28.2921H138.404V29.3886H139.501V28.2921ZM155.063 30.0946L154.241 29.3691L154.238 29.3725L155.063 30.0946ZM137.716 30.0767L136.941 30.8521L136.952 30.8631L136.963 30.8739L137.716 30.0767ZM155.063 16.8525L154.221 17.5544L154.231 17.5663L154.241 17.5779L155.063 16.8525ZM155.063 18.3516L154.221 17.6496L154.217 17.6545L155.063 18.3516ZM137.681 6.59069L136.858 7.31616L136.881 7.34183L136.905 7.36603L137.681 6.59069ZM137.681 5.10943L136.861 4.38096L136.849 4.39404L136.838 4.40748L137.681 5.10943ZM155.063 6.59069L154.241 5.86523L154.238 5.86865L155.063 6.59069ZM154.314 18.655V17.5585H139.501V18.655V19.7514H154.314V18.655ZM139.501 18.655H138.404V28.2921H139.501H140.597V18.655H139.501ZM139.501 28.2921V29.3886H154.314V28.2921V27.1956H139.501V28.2921ZM154.314 28.2921V29.3886C154.352 29.3886 154.344 29.3948 154.31 29.3802C154.293 29.3731 154.275 29.363 154.258 29.35C154.241 29.337 154.228 29.3244 154.221 29.3153L155.063 28.6133L155.905 27.9114C155.486 27.4076 154.905 27.1956 154.314 27.1956V28.2921ZM155.063 28.6133L154.221 29.3153C154.227 29.3226 154.23 29.327 154.23 29.3286C154.231 29.3294 154.231 29.3299 154.231 29.33C154.231 29.3301 154.231 29.3301 154.231 29.3301C154.231 29.3302 154.231 29.3305 154.232 29.3312C154.232 29.332 154.232 29.3334 154.232 29.3357C154.233 29.34 154.234 29.3488 154.234 29.3629H155.331H156.427C156.427 28.8276 156.252 28.3277 155.905 27.9114L155.063 28.6133ZM155.331 29.3629H154.234C154.234 29.377 154.233 29.3847 154.233 29.387C154.232 29.3891 154.233 29.3875 154.234 29.3832C154.236 29.3789 154.238 29.3746 154.24 29.3709C154.242 29.3674 154.243 29.3668 154.241 29.3691L155.063 30.0946L155.885 30.82C156.251 30.405 156.427 29.8985 156.427 29.3629H155.331ZM155.063 30.0946L154.238 29.3725C154.257 29.3512 154.279 29.3315 154.302 29.3152C154.326 29.299 154.347 29.2894 154.36 29.2841C154.387 29.2741 154.378 29.2836 154.314 29.2836V30.3801V31.4766C154.857 31.4766 155.452 31.3147 155.888 30.8166L155.063 30.0946ZM154.314 30.3801V29.2836H138.484V30.3801V31.4766H154.314V30.3801ZM138.484 30.3801V29.2836C138.472 29.2836 138.466 29.2826 138.466 29.2825C138.465 29.2825 138.468 29.283 138.472 29.2846C138.476 29.2862 138.479 29.2878 138.479 29.2883C138.48 29.2886 138.476 29.2865 138.469 29.2796L137.716 30.0767L136.963 30.8739C137.383 31.2705 137.909 31.4766 138.484 31.4766V30.3801ZM137.716 30.0767L138.492 29.3014C138.489 29.2986 138.49 29.2997 138.494 29.3051C138.498 29.3107 138.502 29.318 138.505 29.3263C138.508 29.3344 138.51 29.3402 138.51 29.3421C138.51 29.3437 138.509 29.3393 138.509 29.3272H137.413H136.316C136.316 29.9025 136.524 30.4352 136.941 30.8521L137.716 30.0767ZM137.413 29.3272H138.509V17.5842H137.413H136.316V29.3272H137.413ZM137.413 17.5842H138.509C138.509 17.5877 138.509 17.5957 138.507 17.6067C138.504 17.6177 138.501 17.6281 138.497 17.6368C138.493 17.6453 138.491 17.6492 138.491 17.6482C138.492 17.6471 138.497 17.64 138.509 17.6278L137.734 16.8525L136.959 16.0771C136.563 16.4728 136.316 16.9873 136.316 17.5842H137.413ZM137.734 16.8525L138.509 17.6278C138.52 17.6174 138.525 17.6135 138.526 17.6134C138.526 17.6134 138.525 17.614 138.523 17.6152C138.521 17.6164 138.518 17.6178 138.514 17.6194C138.506 17.6226 138.498 17.6251 138.491 17.6265C138.484 17.6279 138.481 17.6277 138.484 17.6277V16.5312V15.4347C137.888 15.4347 137.365 15.6712 136.959 16.0771L137.734 16.8525ZM138.484 16.5312V17.6277H154.314V16.5312V15.4347H138.484V16.5312ZM154.314 16.5312V17.6277C154.352 17.6277 154.344 17.6339 154.31 17.6194C154.293 17.6123 154.275 17.6021 154.258 17.5891C154.241 17.5761 154.228 17.5635 154.221 17.5544L155.063 16.8525L155.905 16.1505C155.486 15.6467 154.905 15.4347 154.314 15.4347V16.5312ZM155.063 16.8525L154.241 17.5779C154.243 17.5803 154.242 17.5796 154.24 17.5761C154.238 17.5725 154.236 17.5681 154.234 17.5638C154.233 17.5596 154.232 17.5579 154.233 17.56C154.233 17.5623 154.234 17.57 154.234 17.5842H155.331H156.427C156.427 17.0485 156.251 16.542 155.885 16.127L155.063 16.8525ZM155.331 17.5842H154.234C154.234 17.6219 154.229 17.637 154.229 17.6379C154.228 17.6391 154.228 17.6397 154.227 17.6404C154.227 17.6412 154.225 17.6443 154.221 17.6496L155.063 18.3516L155.905 19.0535C156.26 18.6285 156.427 18.1196 156.427 17.5842H155.331ZM155.063 18.3516L154.217 17.6545C154.233 17.6351 154.253 17.6154 154.277 17.5981C154.301 17.5808 154.323 17.5695 154.339 17.5627C154.372 17.5495 154.371 17.5585 154.314 17.5585V18.655V19.7514C154.878 19.7514 155.48 19.5699 155.91 19.0486L155.063 18.3516ZM154.314 6.87624V5.77975H138.484V6.87624V7.97273H154.314V6.87624ZM138.484 6.87624V5.77975C138.41 5.77975 138.385 5.76948 138.391 5.77172C138.395 5.77299 138.405 5.77691 138.418 5.78512C138.431 5.79344 138.444 5.80382 138.456 5.81536L137.681 6.59069L136.905 7.36603C137.355 7.81564 137.934 7.97273 138.484 7.97273V6.87624ZM137.681 6.59069L138.503 5.86523C138.501 5.8629 138.502 5.8635 138.504 5.86705C138.506 5.87067 138.508 5.87504 138.51 5.87934C138.511 5.88357 138.511 5.88524 138.511 5.88311C138.51 5.88081 138.509 5.87316 138.509 5.85899H137.413H136.316C136.316 6.39463 136.492 6.90113 136.858 7.31616L137.681 6.59069ZM137.413 5.85899H138.509C138.509 5.84487 138.51 5.83613 138.511 5.83178C138.512 5.82954 138.512 5.82811 138.512 5.82735C138.512 5.8266 138.512 5.82626 138.512 5.82623C138.512 5.8262 138.512 5.82618 138.512 5.82608C138.513 5.82598 138.513 5.82553 138.513 5.82468C138.514 5.82316 138.517 5.81871 138.523 5.81139L137.681 5.10943L136.838 4.40748C136.491 4.82385 136.316 5.32373 136.316 5.85899H137.413ZM137.681 5.10943L138.5 5.8379C138.493 5.84641 138.482 5.85674 138.467 5.86662C138.453 5.87649 138.441 5.8829 138.431 5.88657C138.413 5.89394 138.424 5.88469 138.484 5.88469V4.78819V3.6917C137.895 3.6917 137.302 3.88524 136.861 4.38096L137.681 5.10943ZM138.484 4.78819V5.88469H154.314V4.78819V3.6917H138.484V4.78819ZM154.314 4.78819V5.88469C154.352 5.88469 154.344 5.89093 154.31 5.87634C154.293 5.86925 154.275 5.85913 154.258 5.84608C154.241 5.83311 154.228 5.82052 154.221 5.81139L155.063 5.10943L155.905 4.40748C155.486 3.90369 154.905 3.6917 154.314 3.6917V4.78819ZM155.063 5.10943L154.221 5.81139C154.227 5.81871 154.23 5.82316 154.23 5.82468C154.231 5.82553 154.231 5.82598 154.231 5.82608C154.231 5.82618 154.231 5.8262 154.231 5.82623C154.231 5.82626 154.231 5.8266 154.232 5.82735C154.232 5.82811 154.232 5.82954 154.232 5.83178C154.233 5.83613 154.234 5.84487 154.234 5.85899H155.331H156.427C156.427 5.32373 156.252 4.82385 155.905 4.40748L155.063 5.10943ZM155.331 5.85899H154.234C154.234 5.87316 154.233 5.88081 154.233 5.88311C154.232 5.88524 154.233 5.88357 154.234 5.87934C154.236 5.87504 154.238 5.87067 154.24 5.86705C154.242 5.8635 154.243 5.8629 154.241 5.86523L155.063 6.59069L155.885 7.31616C156.251 6.90113 156.427 6.39463 156.427 5.85899H155.331ZM155.063 6.59069L154.238 5.86865C154.257 5.84727 154.279 5.82765 154.302 5.81131C154.326 5.79514 154.347 5.78547 154.36 5.7802C154.387 5.77022 154.378 5.77975 154.314 5.77975V6.87624V7.97273C154.857 7.97273 155.452 7.81081 155.888 7.31274L155.063 6.59069ZM179.12 30.0232L178.282 30.7304L178.285 30.7333L179.12 30.0232ZM169.947 19.1547L170.785 18.4474L169.947 17.4546L169.109 18.4474L169.947 19.1547ZM160.774 30.0232L161.609 30.7333L161.612 30.7304L160.774 30.0232ZM159.275 30.0767L158.5 30.8521L158.511 30.8631L158.522 30.8739L159.275 30.0767ZM159.239 28.7026L158.401 27.9952L158.397 28.0006L159.239 28.7026ZM168.626 17.5842L169.464 18.2915L170.062 17.5836L169.464 16.8761L168.626 17.5842ZM159.239 6.48362L158.397 7.18559L158.402 7.19164L159.239 6.48362ZM159.293 5.10943L160.046 5.9066L160.047 5.90543L159.293 5.10943ZM160.774 5.16297L161.611 4.45506L161.607 4.44938L160.774 5.16297ZM169.947 16.0137L169.11 16.7216L169.947 17.7121L170.784 16.7216L169.947 16.0137ZM179.12 5.16297L178.288 4.44937L178.283 4.45507L179.12 5.16297ZM180.601 5.10943L179.804 5.86231L179.815 5.87369L179.826 5.88477L180.601 5.10943ZM180.655 6.48362L181.492 7.19164L181.497 7.18618L181.501 7.18066L180.655 6.48362ZM171.268 17.5842L170.431 16.8761L169.832 17.5836L170.43 18.2915L171.268 17.5842ZM180.655 28.7026L181.502 28.0055L181.493 27.9952L180.655 28.7026ZM179.12 30.0232L179.958 29.316L170.785 18.4474L169.947 19.1547L169.109 19.8619L178.282 30.7304L179.12 30.0232ZM169.947 19.1547L169.109 18.4474L159.936 29.316L160.774 30.0232L161.612 30.7304L170.785 19.8619L169.947 19.1547ZM160.774 30.0232L159.939 29.3131C159.933 29.3198 159.932 29.3191 159.938 29.3144C159.945 29.3096 159.955 29.3029 159.968 29.2967C159.981 29.2904 159.994 29.2867 160.003 29.2848C160.011 29.283 160.013 29.2836 160.007 29.2836V30.3801V31.4766C160.641 31.4766 161.201 31.2137 161.609 30.7333L160.774 30.0232ZM160.007 30.3801V29.2836C160.006 29.2836 160.01 29.2836 160.017 29.285C160.024 29.2864 160.032 29.2887 160.038 29.2914C160.045 29.2941 160.048 29.296 160.047 29.2953C160.045 29.2945 160.039 29.2901 160.028 29.2796L159.275 30.0767L158.522 30.8739C158.923 31.2523 159.43 31.4766 160.007 31.4766V30.3801ZM159.275 30.0767L160.05 29.3014C160.043 29.2946 160.043 29.2927 160.045 29.2961C160.047 29.2997 160.052 29.3071 160.056 29.3177C160.061 29.3284 160.064 29.3392 160.066 29.3488C160.068 29.3582 160.068 29.3634 160.068 29.3629H158.971H157.875C157.875 29.9417 158.102 30.4546 158.5 30.8521L159.275 30.0767ZM158.971 29.3629H160.068C160.068 29.379 160.066 29.3949 160.063 29.4095C160.061 29.4239 160.057 29.4344 160.055 29.4402C160.05 29.4516 160.053 29.4392 160.082 29.4045L159.239 28.7026L158.397 28.0006C158.094 28.3643 157.875 28.8246 157.875 29.3629H158.971ZM159.239 28.7026L160.077 29.4099L169.464 18.2915L168.626 17.5842L167.789 16.8768L158.401 27.9952L159.239 28.7026ZM168.626 17.5842L169.464 16.8761L160.076 5.77559L159.239 6.48362L158.402 7.19164L167.789 18.2922L168.626 17.5842ZM159.239 6.48362L160.082 5.78166C160.053 5.74694 160.05 5.73452 160.055 5.74596C160.057 5.75179 160.061 5.76222 160.063 5.77668C160.066 5.79126 160.068 5.80714 160.068 5.82329H158.971H157.875C157.875 6.36153 158.094 6.82184 158.397 7.18557L159.239 6.48362ZM158.971 5.82329H160.068C160.068 5.82682 160.068 5.83607 160.065 5.84938C160.062 5.86285 160.058 5.87669 160.052 5.88955C160.039 5.91716 160.029 5.9219 160.046 5.9066L159.293 5.10943L158.54 4.31227C158.125 4.704 157.875 5.22317 157.875 5.82329H158.971ZM159.293 5.10943L160.047 5.90543C160.063 5.88985 160.075 5.88149 160.08 5.87772C160.086 5.87406 160.086 5.87442 160.082 5.87634C160.077 5.87833 160.07 5.88076 160.061 5.88252C160.053 5.88428 160.046 5.88469 160.042 5.88469V4.78819V3.6917C159.449 3.6917 158.938 3.93504 158.539 4.31343L159.293 5.10943ZM160.042 4.78819V5.88469C160.026 5.88469 160.007 5.88278 159.985 5.8775C159.963 5.87222 159.944 5.86487 159.931 5.85781C159.903 5.84364 159.909 5.83862 159.941 5.87656L160.774 5.16297L161.607 4.44938C161.23 4.01051 160.701 3.6917 160.042 3.6917V4.78819ZM160.774 5.16297L159.937 5.87087L169.11 16.7216L169.947 16.0137L170.784 15.3058L161.611 4.45507L160.774 5.16297ZM169.947 16.0137L170.784 16.7216L179.958 5.87087L179.12 5.16297L178.283 4.45507L169.11 15.3058L169.947 16.0137ZM179.12 5.16297L179.953 5.87656C179.978 5.84764 179.98 5.85453 179.954 5.86716C179.942 5.87307 179.928 5.87801 179.914 5.88118C179.9 5.88431 179.891 5.88469 179.888 5.88469V4.78819V3.6917C179.234 3.6917 178.685 3.98558 178.288 4.44938L179.12 5.16297ZM179.888 4.78819V5.88469C179.884 5.88469 179.875 5.88429 179.862 5.88151C179.848 5.87869 179.834 5.87421 179.821 5.86842C179.794 5.856 179.789 5.8461 179.804 5.86231L180.601 5.10943L181.399 4.35656C181.007 3.94178 180.488 3.6917 179.888 3.6917V4.78819ZM180.601 5.10943L179.826 5.88477C179.833 5.89153 179.834 5.89349 179.831 5.89005C179.829 5.88642 179.824 5.87911 179.82 5.86848C179.815 5.85778 179.812 5.84698 179.81 5.83738C179.808 5.82794 179.808 5.82276 179.808 5.82329H180.905H182.001C182.001 5.24449 181.774 4.73161 181.377 4.3341L180.601 5.10943ZM180.905 5.82329H179.808C179.808 5.81846 179.809 5.81115 179.81 5.80227C179.812 5.79336 179.814 5.7853 179.817 5.7788C179.822 5.76481 179.824 5.76756 179.809 5.78657L180.655 6.48362L181.501 7.18066C181.812 6.80329 182.001 6.34174 182.001 5.82329H180.905ZM180.655 6.48362L179.818 5.77559L170.431 16.8761L171.268 17.5842L172.105 18.2922L181.492 7.19164L180.655 6.48362ZM171.268 17.5842L170.43 18.2915L179.817 29.4099L180.655 28.7026L181.493 27.9952L172.106 16.8768L171.268 17.5842ZM180.655 28.7026L179.809 29.3996C179.824 29.4186 179.822 29.4214 179.817 29.4074C179.814 29.4009 179.812 29.3928 179.81 29.3839C179.809 29.375 179.808 29.3677 179.808 29.3629H180.905H182.001C182.001 28.8444 181.812 28.3829 181.501 28.0055L180.655 28.7026ZM180.905 29.3629H179.808C179.808 29.3593 179.809 29.3501 179.812 29.3368C179.814 29.3233 179.819 29.3095 179.825 29.2966C179.837 29.269 179.847 29.2643 179.831 29.2796L180.584 30.0767L181.337 30.8739C181.751 30.4822 182.001 29.963 182.001 29.3629H180.905ZM180.584 30.0767L179.831 29.2796C179.82 29.2901 179.813 29.2945 179.812 29.2953C179.811 29.296 179.814 29.2941 179.82 29.2914C179.827 29.2887 179.834 29.2864 179.841 29.285C179.848 29.2836 179.852 29.2836 179.852 29.2836V30.3801V31.4766C180.428 31.4766 180.936 31.2523 181.337 30.8739L180.584 30.0767ZM179.852 30.3801V29.2836C179.857 29.2836 179.869 29.2842 179.886 29.288C179.903 29.2918 179.92 29.2978 179.936 29.3054C179.969 29.3215 179.974 29.334 179.956 29.3131L179.12 30.0232L178.285 30.7333C178.673 31.1904 179.212 31.4766 179.852 31.4766V30.3801Z",
    fill: "#3AD2AF",
    mask: "url(#path-31-outside-1_3399_2250)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-33-outside-2_3399_2250",
    maskUnits: "userSpaceOnUse",
    x: 184.099,
    y: 3.38013,
    width: 51,
    height: 29,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 184.099,
    y: 3.38013,
    width: 51,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.194 30.3801H198.716C196.991 30.3801 195.337 30.041 193.754 29.3629C192.172 28.6847 190.81 27.7745 189.667 26.6324C188.525 25.4902 187.615 24.1279 186.937 22.5455C186.259 20.9631 185.92 19.3093 185.92 17.5842C185.92 15.859 186.259 14.2052 186.937 12.6228C187.615 11.0404 188.525 9.67815 189.667 8.53597C190.81 7.39379 192.172 6.48362 193.754 5.80545C195.337 5.12728 196.991 4.78819 198.716 4.78819H205.194C205.515 4.78819 205.765 4.89527 205.944 5.10943C206.122 5.32359 206.211 5.57344 206.211 5.85899C206.211 6.14453 206.122 6.38843 205.944 6.59069C205.777 6.78106 205.527 6.87624 205.194 6.87624H198.716C197.264 6.87624 195.872 7.16178 194.54 7.73287C193.219 8.29206 192.083 9.04757 191.131 9.99938C190.179 10.9512 189.418 12.0934 188.847 13.4259C188.287 14.7466 188.008 16.1326 188.008 17.5842C188.008 19.0357 188.287 20.4277 188.847 21.7603C189.418 23.0809 190.179 24.2171 191.131 25.1689C192.083 26.1208 193.219 26.8822 194.54 27.4533C195.872 28.0125 197.264 28.2921 198.716 28.2921H205.194C205.515 28.2921 205.765 28.3992 205.944 28.6133C206.122 28.8275 206.211 29.0773 206.211 29.3629C206.211 29.6484 206.122 29.8923 205.944 30.0946C205.777 30.2849 205.527 30.3801 205.194 30.3801ZM228.662 9.94584C226.544 7.82805 223.998 6.76916 221.024 6.76916C218.049 6.76916 215.503 7.82805 213.386 9.94584C211.268 12.0636 210.209 14.6097 210.209 17.5842C210.209 20.5586 211.268 23.1047 213.386 25.2225C215.503 27.3403 218.049 28.3992 221.024 28.3992C223.998 28.3992 226.544 27.3403 228.662 25.2225C230.792 23.0928 231.857 20.5467 231.857 17.5842C231.857 14.6216 230.792 12.0755 228.662 9.94584ZM230.197 26.7573C227.663 29.2915 224.605 30.5586 221.024 30.5586C217.443 30.5586 214.385 29.2915 211.851 26.7573C209.317 24.2231 208.049 21.1654 208.049 17.5842C208.049 14.003 209.317 10.9452 211.851 8.41104C214.385 5.87683 217.443 4.60973 221.024 4.60973C224.605 4.60973 227.663 5.87683 230.197 8.41104C232.731 10.9452 233.998 14.003 233.998 17.5842C233.998 21.1654 232.731 24.2231 230.197 26.7573Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.194 30.3801H198.716C196.991 30.3801 195.337 30.041 193.754 29.3629C192.172 28.6847 190.81 27.7745 189.667 26.6324C188.525 25.4902 187.615 24.1279 186.937 22.5455C186.259 20.9631 185.92 19.3093 185.92 17.5842C185.92 15.859 186.259 14.2052 186.937 12.6228C187.615 11.0404 188.525 9.67815 189.667 8.53597C190.81 7.39379 192.172 6.48362 193.754 5.80545C195.337 5.12728 196.991 4.78819 198.716 4.78819H205.194C205.515 4.78819 205.765 4.89527 205.944 5.10943C206.122 5.32359 206.211 5.57344 206.211 5.85899C206.211 6.14453 206.122 6.38843 205.944 6.59069C205.777 6.78106 205.527 6.87624 205.194 6.87624H198.716C197.264 6.87624 195.872 7.16178 194.54 7.73287C193.219 8.29206 192.083 9.04757 191.131 9.99938C190.179 10.9512 189.418 12.0934 188.847 13.4259C188.287 14.7466 188.008 16.1326 188.008 17.5842C188.008 19.0357 188.287 20.4277 188.847 21.7603C189.418 23.0809 190.179 24.2171 191.131 25.1689C192.083 26.1208 193.219 26.8822 194.54 27.4533C195.872 28.0125 197.264 28.2921 198.716 28.2921H205.194C205.515 28.2921 205.765 28.3992 205.944 28.6133C206.122 28.8275 206.211 29.0773 206.211 29.3629C206.211 29.6484 206.122 29.8923 205.944 30.0946C205.777 30.2849 205.527 30.3801 205.194 30.3801ZM228.662 9.94584C226.544 7.82805 223.998 6.76916 221.024 6.76916C218.049 6.76916 215.503 7.82805 213.386 9.94584C211.268 12.0636 210.209 14.6097 210.209 17.5842C210.209 20.5586 211.268 23.1047 213.386 25.2225C215.503 27.3403 218.049 28.3992 221.024 28.3992C223.998 28.3992 226.544 27.3403 228.662 25.2225C230.792 23.0928 231.857 20.5467 231.857 17.5842C231.857 14.6216 230.792 12.0755 228.662 9.94584ZM230.197 26.7573C227.663 29.2915 224.605 30.5586 221.024 30.5586C217.443 30.5586 214.385 29.2915 211.851 26.7573C209.317 24.2231 208.049 21.1654 208.049 17.5842C208.049 14.003 209.317 10.9452 211.851 8.41104C214.385 5.87683 217.443 4.60973 221.024 4.60973C224.605 4.60973 227.663 5.87683 230.197 8.41104C232.731 10.9452 233.998 14.003 233.998 17.5842C233.998 21.1654 232.731 24.2231 230.197 26.7573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.944 6.59069L205.121 5.86523L205.118 5.86865L205.944 6.59069ZM194.54 7.73287L194.967 8.74259L194.972 8.74071L194.54 7.73287ZM188.847 13.4259L187.839 12.994L187.837 12.9984L188.847 13.4259ZM188.847 21.7603L187.835 22.1846L187.84 22.1955L188.847 21.7603ZM194.54 27.4533L194.104 28.4598L194.115 28.4644L194.54 27.4533ZM205.944 30.0946L205.121 29.3691L205.118 29.3725L205.944 30.0946ZM205.194 30.3801V29.2836H198.716V30.3801V31.4766H205.194V30.3801ZM198.716 30.3801V29.2836C197.139 29.2836 195.632 28.9746 194.186 28.355L193.754 29.3629L193.322 30.3707C195.042 31.1075 196.842 31.4766 198.716 31.4766V30.3801ZM193.754 29.3629L194.186 28.355C192.724 27.7282 191.48 26.8942 190.443 25.857L189.667 26.6324L188.892 27.4077C190.139 28.6549 191.62 29.6412 193.322 30.3707L193.754 29.3629ZM189.667 26.6324L190.443 25.857C189.406 24.8198 188.572 23.5763 187.945 22.1136L186.937 22.5455L185.929 22.9774C186.659 24.6795 187.645 26.1605 188.892 27.4077L189.667 26.6324ZM186.937 22.5455L187.945 22.1136C187.325 20.668 187.016 19.1611 187.016 17.5842H185.92H184.823C184.823 19.4575 185.192 21.2583 185.929 22.9774L186.937 22.5455ZM185.92 17.5842H187.016C187.016 16.0072 187.325 14.5004 187.945 13.0548L186.937 12.6228L185.929 12.1909C185.192 13.9101 184.823 15.7108 184.823 17.5842H185.92ZM186.937 12.6228L187.945 13.0548C188.572 11.592 189.406 10.3485 190.443 9.3113L189.667 8.53597L188.892 7.76063C187.645 9.0078 186.659 10.4888 185.929 12.1909L186.937 12.6228ZM189.667 8.53597L190.443 9.3113C191.48 8.27412 192.724 7.44016 194.186 6.81328L193.754 5.80545L193.322 4.79761C191.62 5.52708 190.139 6.51346 188.892 7.76063L189.667 8.53597ZM193.754 5.80545L194.186 6.81328C195.632 6.19373 197.139 5.88469 198.716 5.88469V4.78819V3.6917C196.842 3.6917 195.042 4.06082 193.322 4.79761L193.754 5.80545ZM198.716 4.78819V5.88469H205.194V4.78819V3.6917H198.716V4.78819ZM205.194 4.78819V5.88469C205.233 5.88469 205.224 5.89093 205.19 5.87634C205.174 5.86925 205.156 5.85913 205.138 5.84608C205.121 5.83311 205.109 5.82052 205.101 5.81139L205.944 5.10943L206.786 4.40748C206.366 3.90369 205.785 3.6917 205.194 3.6917V4.78819ZM205.944 5.10943L205.101 5.81139C205.107 5.81871 205.11 5.82316 205.111 5.82468C205.111 5.82553 205.112 5.82598 205.112 5.82608C205.112 5.82618 205.112 5.8262 205.112 5.82623C205.112 5.82626 205.112 5.8266 205.112 5.82735C205.112 5.82811 205.113 5.82954 205.113 5.83178C205.114 5.83613 205.115 5.84487 205.115 5.85899H206.211H207.308C207.308 5.32373 207.133 4.82385 206.786 4.40748L205.944 5.10943ZM206.211 5.85899H205.115C205.115 5.87316 205.114 5.88081 205.113 5.88311C205.113 5.88524 205.113 5.88357 205.115 5.87934C205.116 5.87504 205.118 5.87067 205.12 5.86705C205.123 5.8635 205.123 5.8629 205.121 5.86523L205.944 6.59069L206.766 7.31616C207.132 6.90113 207.308 6.39463 207.308 5.85899H206.211ZM205.944 6.59069L205.118 5.86865C205.137 5.84727 205.159 5.82765 205.183 5.81131C205.206 5.79514 205.227 5.78547 205.241 5.7802C205.267 5.77022 205.259 5.77975 205.194 5.77975V6.87624V7.97273C205.737 7.97273 206.333 7.81081 206.769 7.31274L205.944 6.59069ZM205.194 6.87624V5.77975H198.716V6.87624V7.97273H205.194V6.87624ZM198.716 6.87624V5.77975C197.116 5.77975 195.577 6.09538 194.108 6.72504L194.54 7.73287L194.972 8.74071C196.167 8.22819 197.412 7.97273 198.716 7.97273V6.87624ZM194.54 7.73287L194.112 6.72317C192.67 7.33373 191.414 8.16606 190.356 9.22405L191.131 9.99938L191.906 10.7747C192.752 9.92908 193.768 9.2504 194.967 8.74258L194.54 7.73287ZM191.131 9.99938L190.356 9.22405C189.298 10.2819 188.46 11.5432 187.839 12.994L188.847 13.4259L189.854 13.8578C190.375 12.6436 191.06 11.6205 191.906 10.7747L191.131 9.99938ZM188.847 13.4259L187.837 12.9984C187.22 14.456 186.911 15.9876 186.911 17.5842H188.008H189.104C189.104 16.2777 189.355 15.0372 189.856 13.8535L188.847 13.4259ZM188.008 17.5842H186.911C186.911 19.1807 187.22 20.717 187.835 22.1845L188.847 21.7603L189.858 21.336C189.355 20.1384 189.104 18.8906 189.104 17.5842H188.008ZM188.847 21.7603L187.84 22.1955C188.462 23.6342 189.299 24.8881 190.356 25.9443L191.131 25.1689L191.906 24.3936C191.059 23.5462 190.373 22.5276 189.853 21.325L188.847 21.7603ZM191.131 25.1689L190.356 25.9443C191.412 27.0005 192.666 27.8376 194.104 28.4597L194.54 27.4533L194.975 26.4469C193.772 25.9269 192.754 25.241 191.906 24.3936L191.131 25.1689ZM194.54 27.4533L194.115 28.4644C195.583 29.0802 197.119 29.3886 198.716 29.3886V28.2921V27.1956C197.409 27.1956 196.161 26.9448 194.964 26.4422L194.54 27.4533ZM198.716 28.2921V29.3886H205.194V28.2921V27.1956H198.716V28.2921ZM205.194 28.2921V29.3886C205.233 29.3886 205.224 29.3948 205.19 29.3802C205.174 29.3731 205.156 29.363 205.138 29.35C205.121 29.337 205.109 29.3244 205.101 29.3153L205.944 28.6133L206.786 27.9114C206.366 27.4076 205.785 27.1956 205.194 27.1956V28.2921ZM205.944 28.6133L205.101 29.3153C205.107 29.3226 205.11 29.327 205.111 29.3286C205.111 29.3294 205.112 29.3299 205.112 29.33C205.112 29.3301 205.112 29.3301 205.112 29.3301C205.112 29.3302 205.112 29.3305 205.112 29.3312C205.112 29.332 205.113 29.3334 205.113 29.3357C205.114 29.34 205.115 29.3488 205.115 29.3629H206.211H207.308C207.308 28.8276 207.133 28.3277 206.786 27.9114L205.944 28.6133ZM206.211 29.3629H205.115C205.115 29.377 205.114 29.3847 205.113 29.387C205.113 29.3891 205.113 29.3875 205.115 29.3832C205.116 29.3789 205.118 29.3746 205.12 29.3709C205.123 29.3674 205.123 29.3668 205.121 29.3691L205.944 30.0946L206.766 30.82C207.132 30.405 207.308 29.8985 207.308 29.3629H206.211ZM205.944 30.0946L205.118 29.3725C205.137 29.3512 205.159 29.3315 205.183 29.3152C205.206 29.299 205.227 29.2894 205.241 29.2841C205.267 29.2741 205.259 29.2836 205.194 29.2836V30.3801V31.4766C205.737 31.4766 206.333 31.3147 206.769 30.8166L205.944 30.0946ZM228.662 9.94584L229.438 9.17051C227.116 6.84869 224.291 5.67267 221.024 5.67267V6.76916V7.86565C223.705 7.86565 225.973 8.80742 227.887 10.7212L228.662 9.94584ZM221.024 6.76916V5.67267C217.756 5.67267 214.932 6.84869 212.61 9.17051L213.386 9.94584L214.161 10.7212C216.075 8.80742 218.342 7.86565 221.024 7.86565V6.76916ZM213.386 9.94584L212.61 9.17051C210.288 11.4923 209.112 14.3167 209.112 17.5842H210.209H211.305C211.305 14.9028 212.247 12.6349 214.161 10.7212L213.386 9.94584ZM210.209 17.5842H209.112C209.112 20.8516 210.288 23.676 212.61 25.9978L213.386 25.2225L214.161 24.4471C212.247 22.5334 211.305 20.2655 211.305 17.5842H210.209ZM213.386 25.2225L212.61 25.9978C214.932 28.3196 217.756 29.4957 221.024 29.4957V28.3992V27.3027C218.342 27.3027 216.075 26.3609 214.161 24.4471L213.386 25.2225ZM221.024 28.3992V29.4957C224.291 29.4957 227.116 28.3196 229.438 25.9978L228.662 25.2225L227.887 24.4471C225.973 26.3609 223.705 27.3027 221.024 27.3027V28.3992ZM228.662 25.2225L229.438 25.9978C231.769 23.6663 232.953 20.8429 232.953 17.5842H231.857H230.76C230.76 20.2505 229.815 22.5192 227.887 24.4471L228.662 25.2225ZM231.857 17.5842H232.953C232.953 14.3254 231.769 11.502 229.438 9.17051L228.662 9.94584L227.887 10.7212C229.815 12.6491 230.76 14.9178 230.76 17.5842H231.857ZM230.197 26.7573L229.422 25.9819C227.093 28.3107 224.314 29.4621 221.024 29.4621V30.5586V31.6551C224.896 31.6551 228.233 30.2723 230.972 27.5326L230.197 26.7573ZM221.024 30.5586V29.4621C217.734 29.4621 214.955 28.3107 212.626 25.9819L211.851 26.7573L211.075 27.5326C213.815 30.2723 217.152 31.6551 221.024 31.6551V30.5586ZM211.851 26.7573L212.626 25.9819C210.297 23.6532 209.146 20.8743 209.146 17.5842H208.049H206.953C206.953 21.4564 208.336 24.793 211.075 27.5326L211.851 26.7573ZM208.049 17.5842H209.146C209.146 14.294 210.297 11.5151 212.626 9.18638L211.851 8.41104L211.075 7.6357C208.336 10.3754 206.953 13.7119 206.953 17.5842H208.049ZM211.851 8.41104L212.626 9.18638C214.955 6.85763 217.734 5.70622 221.024 5.70622V4.60973V3.51324C217.152 3.51324 213.815 4.89604 211.075 7.6357L211.851 8.41104ZM221.024 4.60973V5.70622C224.314 5.70622 227.093 6.85763 229.422 9.18638L230.197 8.41104L230.972 7.6357C228.233 4.89604 224.896 3.51324 221.024 3.51324V4.60973ZM230.197 8.41104L229.422 9.18638C231.75 11.5151 232.902 14.294 232.902 17.5842H233.998H235.095C235.095 13.7119 233.712 10.3754 230.972 7.6357L230.197 8.41104ZM233.998 17.5842H232.902C232.902 20.8743 231.75 23.6532 229.422 25.9819L230.197 26.7573L230.972 27.5326C233.712 24.793 235.095 21.4564 235.095 17.5842H233.998Z",
    fill: "white",
    mask: "url(#path-33-outside-2_3399_2250)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter30_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 4,
    r: 1,
    fill: "#FCFCFD"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter32_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter33_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter34_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 4,
    r: 1,
    fill: "#00A693"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter36_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter37_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter38_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter39_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 4,
    r: 1,
    fill: "#777E90"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter40_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter41_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter42_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter43_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 18,
    r: 1,
    fill: "#00A693"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter45_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter46_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter47_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 18,
    r: 1,
    fill: "#FCFCFD"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter49_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 18,
    r: 1,
    fill: "#777E90"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter50_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 32,
    r: 1,
    fill: "#00A693"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter52_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter53_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter54_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter55_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 32,
    r: 1,
    fill: "#00A693"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter57_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter58_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter59_d_3399_2250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 32,
    r: 1,
    fill: "#777E90"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3399_2250",
    x: 9.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3399_2250",
    x: 18.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3399_2250",
    x: 27.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3399_2250",
    x: 36.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3399_2250",
    x: 45.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3399_2250",
    x: 54.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.435294 0 0 0 0 0.968627 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3399_2250",
    x: 63.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3399_2250",
    x: 72.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_3399_2250",
    x: 81.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_3399_2250",
    x: 90.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_3399_2250",
    x: 0.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_3399_2250",
    x: 9.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_3399_2250",
    x: 18.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_3399_2250",
    x: 27.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_3399_2250",
    x: 36.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.282353 0 0 0 0 0.6 0 0 0 0 0.921569 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_3399_2250",
    x: 45.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_3399_2250",
    x: 54.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_3399_2250",
    x: 63.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_3399_2250",
    x: 72.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.988235 0 0 0 0 0.992157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_3399_2250",
    x: 81.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_3399_2250",
    x: 9.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_3399_2250",
    x: 18.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_3399_2250",
    x: 27.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_3399_2250",
    x: 36.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_3399_2250",
    x: 45.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_3399_2250",
    x: 54.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_3399_2250",
    x: 63.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.701961 0 0 0 0 0.941176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_3399_2250",
    x: 72.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_3399_2250",
    x: 81.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_3399_2250",
    x: 90.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_3399_2250",
    x: 249.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_3399_2250",
    x: 258.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_3399_2250",
    x: 267.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_3399_2250",
    x: 276.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_3399_2250",
    x: 285.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_d_3399_2250",
    x: 294.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.435294 0 0 0 0 0.968627 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_d_3399_2250",
    x: 303.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_3399_2250",
    x: 312.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_3399_2250",
    x: 321.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_3399_2250",
    x: 330.6,
    y: 0.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_3399_2250",
    x: 258.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_3399_2250",
    x: 267.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_3399_2250",
    x: 276.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_d_3399_2250",
    x: 285.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_d_3399_2250",
    x: 294.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.282353 0 0 0 0 0.6 0 0 0 0 0.921569 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_d_3399_2250",
    x: 303.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_d_3399_2250",
    x: 312.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_d_3399_2250",
    x: 321.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_d_3399_2250",
    x: 330.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.988235 0 0 0 0 0.992157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_d_3399_2250",
    x: 339.6,
    y: 14.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_d_3399_2250",
    x: 249.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_d_3399_2250",
    x: 258.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_d_3399_2250",
    x: 267.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_d_3399_2250",
    x: 276.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_d_3399_2250",
    x: 285.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_d_3399_2250",
    x: 294.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_d_3399_2250",
    x: 303.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.701961 0 0 0 0 0.941176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_d_3399_2250",
    x: 312.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_d_3399_2250",
    x: 321.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_d_3399_2250",
    x: 330.6,
    y: 28.6,
    width: 6.8,
    height: 6.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3399_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3399_2250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3399_2250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 29.2398,
    fill: "white",
    transform: "translate(111 3.38013)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtcExfinito);
export default __webpack_public_path__ + "static/media/otc-exfinito.433e038f795fc32b94bcf41ae0a0bbc1.svg";
export { ForwardRef as ReactComponent };